import { FC } from "react";
import { Box, Button, Paper, Typography } from "@mui/material";
import __ from "src/utils/Translations";
import { styles } from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureAreas/styles";
import { Link } from "react-router-dom";
import { useCompanyId } from "src/Pages/Company/CompanyContext";
import { usePermission } from "src/utils/hooks/permissions/usePermissions";
import { organizationStructureAreaAdd } from "src/utils/RoleBasedSecurity/permissions";

const CreateAreaResult: FC = () => {
  const companyId = useCompanyId();
  const hasPermissionStructureAreaAdd = usePermission(
    organizationStructureAreaAdd
  );

  return (
    <Paper sx={{ gridArea: "1 / span 2", mt: 2, p: 3 }}>
      <Box sx={styles.CreateAreaResult.root}>
        <Typography variant="h5" fontWeight="fontWeightBold">
          {__("Brak obszarów do wyświetlenia")}
        </Typography>
        <Box sx={{ margin: "16px 0" }}>
          <Typography variant="subtitle1">
            {__("Rozpocznij budowę struktury od dodania obszarów")}
          </Typography>
        </Box>
        {hasPermissionStructureAreaAdd && (
          <Button
            component={Link}
            variant="contained"
            size="large"
            to={`/company/edit/${companyId}/organization-structure/configure-structure/create-area`}
          >
            {__("Dodaj obszar")}
          </Button>
        )}
      </Box>
    </Paper>
  );
};

export default CreateAreaResult;
